import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, withRouter } from "react-router-dom";
import { Switch } from "react-router";
import "../../assets/scss/style.scss";
import { Container, Row, Col } from "reactstrap";

import {
  fetchUserPermissions,
  validateToken,
  fetchCurrentUserProfile,
  resetPassword,
} from "../../redux/authentication/actions";

// Import Component
import Header from "../../components/Header";
import Sidenav from "../../components/Sidenav";
import AuthGuard from "../../components/AuthGuard";

// Import Page
import Home from "../../components/HomeScreen";
import Dealer from "../../pages/Dealer";
import Branch from "../../pages/Branch";
import Rides from "../../pages/Rides";
import User from "../../pages/User";
import Events from "../../pages/Events";
import Testing from "../../pages/Testing";
import _ from "lodash";
import Loader from "../../components/Loader";
import Review from "../../pages/Review";
import ImageModerationMain from "../../components/ImageModerationMain";
import VinLookup from "../../components/VinLookup";
import Reports from "../../pages/Reports";
import vin from "../../pages/vin";
import Partner from "../../pages/Partner";
import Moderation from "../../pages/Moderation";

class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSidebar: false,
      tourToggle: false,
    };

    // this.bounceVerifyToken = this.bounceVerifyToken.bind(this);
  }

  componentDidMount() {
    this.bounceVerifyToken();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.token && this.props.token !== prevProps.token) {
      this.bounceVerifyToken();
    }

    if (
      this.props.tokenVerified !== prevProps.tokenVerified &&
      this.props.tokenVerified === true &&
      this.props.userPermissions.length === 0 &&
      this.props.fetchingUserPermissions === false
    ) {
      this.props.fetchUserPermissions();
      this.props.fetchCurrentUserProfile();
    }

    if (
      this.props &&
      this.props.location &&
      this.props.location.pathname === "/"
    ) {
      document.body.classList.add("mainFull-size");
    } else {
      document.body.classList.remove("mainFull-size");
    }
  }

  bounceVerifyToken = _.debounce(async () => {
    this.props.validateToken();
  }, 500);

  handleToggleIcon = () => {
    let state = this.state;
    state.activeSidebar = !state.activeSidebar;
    this.setState({ ...state });
  };

  handleToggle = () => {
    let state = this.state;
    state.tourToggle = !this.state.tourToggle;
    this.setState({ ...state });
  };

  handleChangePassword = (data) => {
    this.props.resetPassword(data);
  };

  withProps(Component, props) {
    return function(matchProps) {
      return <Component {...props} {...matchProps} />;
    };
  }

  render() {
    return (
      <div className="padd-zero">
        {this.props.fetchingUserPermissions && this.props.tokenVerified && (
          <Loader />
        )}

        {this.props.elementsStatus !== false ? <Loader /> : null}
        <Header
          handleToggleIcon={this.handleToggleIcon}
          userData={this.props.userData}
          handleChangePassword={this.handleChangePassword}
          elements={this.props.elements}
          resetPasswordStatus={this.props.resetPasswordStatus}
          resetPasswordModelClose={this.props.resetPasswordModelClose}
          usertype={this.props.usertype}
          handleToggle={this.handleToggle}
          tourToggle={this.state.tourToggle}
          location={this.props.location.pathname}
        />
        <Sidenav
          activeSidebar={this.state.activeSidebar}
          userPermissions={this.props.userPermissions}
          handleToggleIcon={this.handleToggleIcon}
        />
        <main
          className={` main-content-wrapper main ${
            this.state.activeSidebar === true ? "aside-active" : ""
          }`}
        >
          <Container fluid>
            <Row>
              <Col sm={12}>
                <Switch>
                  <Route
                    exact
                    path="/"
                    component={this.withProps(Home, {
                      toggle: this.state.tourToggle,
                    })}
                  />
                  <Route path="/user/:page" component={User} />
                  <Route path="/dealer/:page" component={Dealer} />
                  <Route path="/branch/:page" component={Branch} />
                  <Route path="/rides/:page" component={Rides} />
                  <Route path="/event/:page" component={Events} />
                  <Route
                    path="/gallery/:page"
                    component={ImageModerationMain}
                  />
                  <Route path="/review/:page" component={Review} />
                  <Route path="/testing" component={Testing} />
                  <Route path="/vin/:page" component={vin} />
                  <Route path="/reports/:page" component={Reports} />
                  <Route path="/partner/:page" component={Partner} />
                  <Route path="/activity/:page" component={Moderation} />
                  <Route path="/moderation/:page" component={Moderation} />
                </Switch>
              </Col>
            </Row>
          </Container>
        </main>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    fetchUserPermissions: () => dispatch(fetchUserPermissions()),
    validateToken: () => dispatch(validateToken()),
    fetchCurrentUserProfile: () => dispatch(fetchCurrentUserProfile()),
    resetPassword: (payload) => dispatch(resetPassword(payload)),
  };
}

function mapStateToProps(state) {
  return {
    token: state.Auth.token,
    tokenVerified: state.Auth.tokenVerified,
    loading: state.Auth.loading,
    userPermissions: state.Auth.userPermissions,
    fetchingUserPermissions: state.Auth.fetchingUserPermissions,
    userData: state.Auth.userData,
    usertype: state.Auth.usertype,
    resetPasswordStatus: state.Auth.resetPasswordStatus,
    resetPasswordModelClose: state.Auth.resetPasswordModelClose,
    elements: state.Elements.elements,
    elementsStatus: state.Elements.elementsStatus,
  };
}

export default AuthGuard(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(Main))
);
